import { baseServiceRequest } from "../baseServiceRequest"
import type { IAddress } from "@commonTypes/address"
import type {
  IAutocompleteAddress,
  IValidAddress,
  IValidateAddressParams,
} from "./types"

export const getAddress = async (address_guid: string): Promise<IAddress> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/addresses/${address_guid}?include_attributes=false`,
  })
  return response.data
}

export const autocompleteAddress = async (
  street: string,
): Promise<IAutocompleteAddress[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/addresses/smartystreets/autocomplete/${street}`,
  })
  return response.data
}

export const validateAddress = async (
  params: IValidateAddressParams,
): Promise<IValidAddress[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/addresses/smartystreets/validate`,
    params,
  })
  return response.data
}
